<template>
  <el-menu class="aside-style"
           background-color="#545c64"
           text-color=" #fff"
           active-text-color="#ffd04b"
           default-active="/Home"
           :collapse-transition="false"
           :collapse="isCollapse"
           router>
    <el-menu-item index="/home">
      <i class="el-icon-s-home"></i>
      <span slot="title">首页</span>
    </el-menu-item>
    <el-menu-item :index="'/'+item.menuclick" v-for="(item,index) in menu" :key="index">
      <i :class="item.menuicon"></i>
      <span slot="title">{{item.menuname}}</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  name: "Aside",
  props:{
    isCollapse:Boolean
  },
  data(){
    return{
      // menu:[]
    }
  },
  computed:{
    "menu":{
      get(){
        return this.$store.state.menu;
      }
    }
  }
}
</script>

<style scoped>

.aside-style {
  min-height: 100vh;
  height: 100%;
}

</style>